import React from "react";
import { formatInCompanyTz } from "../../../../../utils/utils";
import styles from "./custom_tooltip.module.css";

export default function CustomTooltip({
  active,
  payload,
  frequency,
  unit,
  color,
  withSeconds = false,
  withTime = true,
}) {
  const date = payload && payload.length > 0 ? payload[0].payload.key : null;

  // const formattedDate = date
  //   ? format(new Date(date), `dd/MM - HH:mm${withSeconds ? ":ss" : ""}`)
  //   : "";

  const formattedDate = () => {
    if (withTime) {
      return formatInCompanyTz(date, `dd/MM - HH:mm${withSeconds ? ":ss" : ""}`);
    } else {
      return formatInCompanyTz(date, "dd/MM");
    }
  };

  const containerWidth = withSeconds ? "83px" : "68px";

  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: color,
        width: containerWidth,
      }}
    >
      {payload && payload.length > 0 && (
        <div className={"d-flex justify-content-center align-items-baseline"}>
          <div style={{ fontSize: "15px" }} className={"pe-1"}>
            {Math.abs(payload[0]?.value).toFixed(1)}
          </div>
          <div style={{ fontSize: "7px" }}>{unit}</div>
        </div>
      )}
      {formattedDate && (
        <div style={{ fontSize: "9px" }}>
          <strong>{formattedDate()}</strong>
        </div>
      )}
    </div>
  );
}
